import { createBrowserRouter } from 'react-router';
import LandingPage from './src/pages/LandingPage';
import RedirectToPanelLogin from './src/pages/RedirectToPanelLogin';
import RedirectToPanelRegister from './src/pages/RedirectToPanelRegister';
import RedirectToPanelVerifyEmail from './src/pages/RedirectToPanelVerifyEmail';
import RefereeDemoPage from './src/pages/RefereeDemoPage';
import PrivacyPolicyPage from './src/pages/PrivacyPolicyPage';
import RegulaminPage from './src/pages/RegulaminPage';
import AccountDeletionPage from './src/pages/AccountDeletionPage';
import SupportPage from './src/pages/SupportPage';
import PublicTournamentsPage from './src/pages/PublicTournamentsPage';
import PublicTournamentDetailsPage from './src/pages/PublicTournamentDetailsPage';

export const router = createBrowserRouter([
  {
    path: '/referee-demo',
    Component: RefereeDemoPage,
  },
  {
    path: '/login',
    Component: RedirectToPanelLogin,
  },
  {
    path: '/register',
    Component: RedirectToPanelRegister,
  },
  {
    path: '/verify-email',
    Component: RedirectToPanelVerifyEmail,
  },
  {
    path: '/polityka-prywatnosci',
    Component: PrivacyPolicyPage,
  },
  {
    path: '/regulamin',
    Component: RegulaminPage,
  },
  {
    path: '/usuniecie-konta',
    Component: AccountDeletionPage,
  },
  {
    path: '/wsparcie',
    Component: SupportPage,
  },
  {
    path: '/account-deletion',
    Component: AccountDeletionPage,
  },
  {
    path: '/support',
    Component: SupportPage,
  },
  {
    path: '/turnieje',
    Component: PublicTournamentsPage,
  },
  {
    path: '/turnieje/:id',
    Component: PublicTournamentDetailsPage,
  },
  {
    path: '/',
    Component: LandingPage,
  },
]);
